module.exports = __webpack_public_path__ + "static/media/site.353317ed.mp4";